import React, {useState, useEffect} from 'react'
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Avatar,
  Popconfirm,
  message,
  Tooltip,
  Alert,
  Radio,
} from 'antd'

import {newUser,RoleModule, RoleUser,User} from 'api/user'
import {useDispatch, useSelector} from 'react-redux'
import {IState} from 'reducers'
import './teachers.less'
import API from 'api'
import {UpdateOrgTypes} from 'reducers/org'
import {getShortDateStr, ObsKeyToURL} from 'api/utils'
import {saveUser} from 'reducers/user'

const phoneRules = [
  {
    required: true,
    message: '请输入正确的手机号码',
    pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
  },
]

interface ResourceCheckOpt {
  label: string
  value: string
}

const TeacherCom = () => {
  const getModuleName = (module: number): string => {
    for (let i = 0; i < orgTypes.length; i++) {
      const element = orgTypes[i]
      if (element.id === module) {
        return element.name
      }
    }
    return ''
  }

  // TODO 后续检查
  const getTeacherExpiry = (teacher: User): string => {
    if (teacher.role?.modules) {
      return getShortDateStr(teacher.role.modules[0]!.expiry!.toString())
    }

    return ''
  }

  const resourceColumns = [
    {
      title: '序号',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: '模块',
      dataIndex: 'module_id',
      key: 'module_id',
      render: value => getModuleName(value),
    },
    {
      title: '年限',
      dataIndex: 'years',
      key: 'years',
    },
    {
      title: '人数',
      dataIndex: 'users',
      key: 'users',
    },
    {
      title: '已用',
      dataIndex: 'activated',
      key: 'activated',
    },
    {
      title: '剩余',
      dataIndex: 'available',
      key: 'available',
    },
  ]

  const teacherColumns = [
    {
      title: '序号',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: '名称',
      dataIndex: 'name_groups',
      key: 'name_groups',
      render: (text, record: User) => (
        <>
          <div className="name-group-wrap">
            <Avatar src={record.image ? ObsKeyToURL(record.image) : ''} />
            <div>{record.name || record.nickname || record.username || record.user_id}</div>
          </div>
        </>
      ),
    },
    {
      title: '登录账号',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '模块',
      dataIndex: 'module_name',
      key: 'module_name',
      render: (text, record: User) => {
        if (record.role?.modules) {
          return getModuleName(record.role.modules[0].module_id)
        }

        return ''
      },
    },
    {
      title: '有效日期',
      dataIndex: 'expire_at',
      key: 'expire_at',
      render: (text, record: User) => getTeacherExpiry(record),
    },
    {
      title: '操作',
      key: 'action',
      render: (text, record: User) => (
        <div>
          <Popconfirm title="确认重置密码为 12345678 ？" onConfirm={() => resetPassword(record)}>
            <Button type="text">重置密码</Button>
          </Popconfirm>
          {compareDate(record.expiry !== undefined ? record.expiry : '') ? (
            <Popconfirm
              title="确认删除用户？"
              okText="确定"
              cancelText="取消"
              onConfirm={() => delTeacher(record)}
            >
              <Button type="text">删除</Button>
            </Popconfirm>
          ) : (
            <Tooltip title="未到有效日期，不能删除">
              <Button type="text" disabled={true}>
                删除
              </Button>
            </Tooltip>
          )}
        </div>
      ),
    },
  ]
  const user = useSelector((state: IState) => state.user)

  const [teacherList, setTeacherList] = useState<User[]>([])
  const [editTeacher, setEditTeacher] = useState<User>(newUser())
  const [teacherModalMode, setTeacherModalMode] = useState('off')

  const [teacherForm] = Form.useForm()
  const dispatch = useDispatch()
  const orgTypes = useSelector((state: IState) => state.org.modules)

  useEffect(() => {
    if (user.role?.modules) {
      const ms: number[] = []
      user.role!.modules!.forEach(role => {
        ms.push(role.module_id)
      })

      dispatch(UpdateOrgTypes(ms))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //第一次渲染时读取user中的人数users,购买年数years,模块module
  useEffect(() => {
    updateTeacherList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.user_id])

  //更新教师信息
  const updateTeacher = (values: any) => {
    //调用接口，更新列表
    let nu = newUser()
    nu.name = values.name
    nu.phone = values.phone
    nu.username = values.username
    nu.user_id = editTeacher.user_id
    if (checkedResource !== '') {
      // TODO 更新教师权限页面
      // let role = editTeacher.roles[0]
      // let resource = purchasedRoles[parseInt(checkedResource)]
      // let ep = new Date(role.expiry)
      // ep.setFullYear(ep.getFullYear() + resource.years)
      // role.expiry = ep.toISOString()
      // role.master_role = {...user.roles[parseInt(checkedResource)]}
      // role.master_role.activated += 1
      // nu.roles = [role]
    }

    setSubmitLoading(true)
    API.editUser(nu).then(res => {
      switch (res.code) {
        case 1002:
          if (res.msg.includes('idx_user_phone')) {
            message.error({
              content: '手机号已被注册，请重新输入!',
              duration: 2,
            })
          } else {
            message.error({
              content: '账号已被注册，请重新输入!',
              duration: 2,
            })
          }
          break
        default:
          message.success({
            content: '修改教师信息成功!',
            duration: 2,
          })
      }
      updateTeacherList()
      closeTeacherModal()
      setSubmitLoading(false)
      updateUser()
    })
  }

  const updateUser = () => {
    API.getUser().then(res => {
      dispatch(saveUser(res.data))
    })
  }

  //添加教师
  const addTeacher = (values: any) => {
    //调用接口，更新列表
    let nu = newUser()
    nu.name = values.name
    nu.phone = values.phone
    nu.username = values.username
    nu.type = 'teacher'
    if (checkedResource === '') {
      message.warn('请分配课程资源', 5)
      return
    }
    let resource = roleUsers[parseInt(checkedResource)]

    let ep = new Date()
    ep.setFullYear(ep.getFullYear() + resource.years)
    let role: RoleModule = {
      expiry: ep,
      module_id: resource.module_id,
    }

    nu.role = {
      modules: [role],
    }
    nu.org = user.org
    nu.expiry = ep.toISOString()

    setSubmitLoading(true)
    let u = {...user}
    u.role!.users![parseInt(checkedResource)].activated += 1
    u.role!.users![parseInt(checkedResource)].available -= 1
    API.addUser(u, nu).then(res => {
      switch (res.code) {
        case 1002:
          if (res.msg.includes('idx_user_phone')) {
            message.error({
              content: '手机号已被注册，请重新输入!',
              duration: 2,
            })
          } else {
            message.error({
              content: '账号已被注册，请重新输入!',
              duration: 2,
            })
          }
          break
        default:
          message.success({
            content: '添加教师成功!',
            duration: 2,
          })
      }
      updateUser()
      updateTeacherList()
      closeTeacherModal()
      setSubmitLoading(false)
    })
  }
  const [submitLoading, setSubmitLoading] = useState(false)

  //判断当前日期是否到达有效期，从而确定删除按钮是否可点击
  const compareDate = (date: string) => {
    let currentDate = new Date()
    let expiry = new Date(date)
    if (currentDate.getTime() > expiry.getTime()) {
      return true
    }
    return false
  }

  //提交表单
  const submitTeacher = (values: any) => {
    if (teacherModalMode === 'add') {
      addTeacher(values)
    } else {
      updateTeacher(values)
    }
    // closeTeacherModal()
  }

  //更新教师列表
  const updateTeacherList = () => {
    if (user.user_id !== '') {
      API.listUser(user.org.org_id).then(res => {
        let tempList: User[] = []
        let users = res.data.users
        if (users) {
          let i = 0
          users.forEach((teacher: User) => {
            if (teacher.type === 'teacher') {
              i = i + 1
              teacher.key = i
              tempList.push(teacher)
            }
          })
        }
        setTeacherList(tempList)
      })
    }
  }

  //删除教师
  const delTeacher = teacher => {
    //调用接口
    message.success({
      content: '删除成功!',
      duration: 2,
    })
    updateTeacherList()
  }

  //重置密码
  const resetPassword = (teacher: User) => {
    let u = newUser()
    u.user_id = teacher.user_id
    u.action = 'resetPassword'
    //调用接口
    API.editUser(u).then(res => {
      message.success({
        content: '重置密码成功,当前密码为12345678!',
        duration: 5,
      })
    })
  }

  //关闭模态框
  const closeTeacherModal = () => {
    setCheckedResource('')
    setTeacherModalMode('off')
    teacherForm.resetFields()
    setEditTeacher(newUser())
  }

  const initCheckList = () => {
    let opts: ResourceCheckOpt[] = []
    let i = 0
    user.role?.users?.forEach(r => {
      if (r.available > 0) {
        opts.push({
          label: getModuleName(r.module_id) + '/' + r.years + '年',
          value: i.toString(),
        })
      }
      i += 1
    })
    setResourceList(opts)
  }

  const [resourceList, setResourceList] = useState<ResourceCheckOpt[]>([])
  const [checkedResource, setCheckedResource] = useState('')
  const checkResource = e => {
    setCheckedResource(e.target.value)
  }

  const [roleUsers, setRoleUsers] = useState<RoleUser[]>([])
  useEffect(() => {
    if (user.user_id !== '') {
      user.role?.users?.forEach((r, index) => {
        r.key = index
        r.available = r.users - r.activated
      })
      setRoleUsers(user.role!.users!)
    } else {
      setRoleUsers([])
    }
  }, [user.user_id, user.role])

  return (
    <>
      <div className="title bold">已购资源</div>
      <Table
        columns={resourceColumns}
        dataSource={roleUsers}
        pagination={false}
        className="purchased-resource-list"
      />
      <div className="teacher-info-title-group">
        <div className="title bold">教师信息管理</div>
        <Button
          type="primary"
          onClick={() => {
            initCheckList()
            setTeacherModalMode('add')
          }}
          className="add-teacher-button"
        >
          添加教师
        </Button>
      </div>
      <Table
        columns={teacherColumns}
        dataSource={teacherList}
        pagination={false}
        className="teacher-list"
      />
      <Modal
        width={450}
        title={teacherModalMode === 'add' ? '添加教师' : '编辑教师'}
        visible={teacherModalMode !== 'off'}
        onCancel={closeTeacherModal}
        confirmLoading={submitLoading}
        onOk={() => {
          teacherForm.validateFields().then(values => {
            submitTeacher(values)
          })
        }}
      >
        <Form form={teacherForm} labelAlign="left" requiredMark={false}>
          <Form.Item
            label="登录账号"
            name="username"
            rules={[{required: true, message: '请输入账号'}]}
            className="teacher-form-item"
          >
            <Input className="teacher-form-item-input" />
          </Form.Item>
          <Form.Item
            label="姓名"
            name="name"
            rules={[{required: true, message: '请输入教师姓名'}]}
            className="teacher-form-item"
          >
            <Input className="teacher-form-item-input" />
          </Form.Item>
          <Form.Item label="手机号" name="phone" rules={phoneRules} className="teacher-form-item">
            <Input className="teacher-form-item-input" />
          </Form.Item>
          <Form.Item label="选择资源" className="teacher-form-item">
            <Radio.Group
              options={resourceList}
              onChange={checkResource}
              value={checkedResource}
              className="check-list-inner"
            />
          </Form.Item>

          {teacherModalMode === 'edit' ? (
            <Form.Item className="teacher-form-item" label="有效日期">
              {getTeacherExpiry(editTeacher)}
            </Form.Item>
          ) : (
            ''
          )}
        </Form>

        {teacherModalMode === 'add' ? (
          <Alert type="success" message="新用户默认密码为： 12345678" />
        ) : (
          ''
        )}
      </Modal>
    </>
  )
}

export default TeacherCom
